const jobopeningsdata = [
    {
        id: 1,
        text: 'Creative Design Intern',
        desc: 'At JN10 Events, we host events in a customized manner based on client ideas.',
        desc2: 'We implement fresh, innovative ideas for unique events.',
    },
    {
        id: 2,
        text: 'Full-Time',
        desc: 'Be part of a full-time role to contribute to our diverse event projects.',
        desc2: 'Bring your creativity to implement new concepts in the event industry.',
    },
    {
        id: 3,
        text: 'Freelancers',
        desc: 'We are looking for freelancers who can contribute with their expertise.',
        desc2: 'Flexible working opportunities with innovative event projects.',
    },
    {
        id: 4,
        text: 'Promoters',
        desc: 'Join as a promoter to represent our events and create memorable experiences.',
        desc2: 'Work with a passionate team to deliver high-quality events.',
    },
];

export default jobopeningsdata;
